/**
 * Active Section Tracker
 * Highlights the current visible section in the navigation menu
 */
document.addEventListener("DOMContentLoaded", function () {
	const HEADER_OFFSET = 400; // Offset for active menu item highlighting
	const SCROLL_OFFSET = 180; // Offset for smooth scroll positioning (smaller = scroll further down)

	const nav = document.querySelector(".wp-block-navigation");

	if (!nav) {
		return;
	}

	// Get all navigation links that point to anchors
	const navLinks = Array.from(nav.querySelectorAll('a[href*="#"]')).filter(link => {
		const href = link.getAttribute("href");
		return href && (href.startsWith("#") || href.startsWith("/#"));
	});

	if (navLinks.length === 0) {
		return;
	}

	// Get all sections that are linked from the navigation
	const sections = navLinks
		.map(link => {
			const href = link.getAttribute("href");
			if (!href || href === "#" || href === "/#") return null;

			// Extract hash from both #kontakt and /#kontakt formats
			const hash = href.includes("#") ? href.substring(href.indexOf("#") + 1) : null;
			if (!hash) return null;

			const section = document.getElementById(hash);
			return section ? { element: section, link: link, id: hash } : null;
		})
		.filter(Boolean);

	if (sections.length === 0) {
		return;
	}

	/**
	 * Get the absolute top position of an element
	 */
	function getAbsoluteTop(element) {
		const rect = element.getBoundingClientRect();
		return rect.top + window.scrollY;
	}

	/**
	 * Close mobile navigation overlay menu
	 */
	function closeMobileMenu() {
		const closeButton = document.querySelector('.wp-block-navigation__responsive-container-close');
		if (closeButton) {
			closeButton.click();
		}
	}

	/**
	 * Smooth scroll to section on click
	 */
	navLinks.forEach(link => {
		link.addEventListener("click", function (e) {
			const href = this.getAttribute("href");
			if (!href || href === "#" || href === "/#") return;

			// Extract hash from both #kontakt and /#kontakt formats
			const hash = href.includes("#") ? href.substring(href.indexOf("#") + 1) : null;
			if (!hash) return;

			const targetElement = document.getElementById(hash);

			if (targetElement) {
				e.preventDefault();

				// Close mobile menu if open
				closeMobileMenu();

				// Smooth scroll to target
				const targetPosition = getAbsoluteTop(targetElement) - SCROLL_OFFSET;
				window.scrollTo({
					top: targetPosition,
					behavior: "smooth"
				});

				// Update URL without jumping
				history.pushState(null, null, href);
			}
		});
	});

	/**
	 * Update active state on navigation links
	 */
	function updateActiveSection() {
		const scrollPosition = window.scrollY + HEADER_OFFSET + 1;

		// Find the current active section
		let currentSection = null;

		for (let i = sections.length - 1; i >= 0; i--) {
			const section = sections[i];
			const sectionTop = getAbsoluteTop(section.element);

			if (scrollPosition >= sectionTop) {
				currentSection = section;
				break;
			}
		}

		// Update active classes
		sections.forEach(section => {
			if (section === currentSection) {
				section.link.classList.add("active");
			} else {
				section.link.classList.remove("active");
			}
		});
	}

	// Update on scroll with throttling
	let ticking = false;
	window.addEventListener("scroll", function () {
		if (!ticking) {
			window.requestAnimationFrame(function () {
				updateActiveSection();
				ticking = false;
			});
			ticking = true;
		}
	});

	// Initial check
	updateActiveSection();
});
